import ProgressiveImageLoader, { SELECTOR } from 'CoreComponents/progressiveImageLoader/';

document.querySelectorAll(SELECTOR).forEach(elem => {
  let loader = new ProgressiveImageLoader(elem);

  loader.load();
});
